export const CONFIG = {
  siteName: 'Somnus',
  siteUrl: import.meta.env.VITE_SITE_URL ?? 'https://somnus.pl',
  contactFormEndpoint: import.meta.env.VITE_CONTACT_FORM_ENDPOINT ?? '',
};

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/somnuscompany',
  linkedin: 'https://www.linkedin.com/company/somnus-sp-z-o-o',
};
